const API_BASE_URL = 'https://prp20-wa-orderlist-api01.azurewebsites.net/api';

export const filterService = {
    getProductListUrl: (providerId) => `${API_BASE_URL}/Filter/GetProductList?providerId=${providerId}`,
    getCustomerTypeUrl: () => `${API_BASE_URL}/Filter/GetCustomerType`,
    getProductOfferUrl: () => `${API_BASE_URL}/Filter/GetProductOffer`
};